import { put, takeLatest, all, select } from 'redux-saga/effects';
import TrackerActions from '@Actions/trackerActions';
import { notification } from 'antd';
import TemplateRouteActions, { templateRouteActionTypes } from '@Actions/production/templateRouteActions';
import TemplateRouteServices from '../../services/production/templateRouteServices';

/**
 * @param action
 */
function* _createTemplateRoute(action) {
  try {
    yield put(TemplateRouteActions.createTemplateRouteLoading(true));
    const templateRoute = yield TemplateRouteServices.createTemplateRoute(action.payload);
    if (templateRoute.success) {
      yield put(TrackerActions.trackAction(templateRouteActionTypes.CREATE_TEMPLATE_ROUTE.SUCCESS, templateRoute.data));
      notification.open({
        type: 'success',
        message: ' Template Route successfully created',
        duration: 4,
        placement: 'top',
      });
      action.callback(templateRoute?.data?.[0]);
    } else {
      notification.open({
        type: 'error',
        message: templateRoute?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(TemplateRouteActions.createTemplateRouteLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(TemplateRouteActions.createTemplateRouteLoading(false));
    yield put(TrackerActions.trackAction(templateRouteActionTypes.CREATE_TEMPLATE_ROUTE.ERROR, error));
  }
}

/**
 *
 */
function* createTemplateRoute() {
  yield takeLatest(templateRouteActionTypes.CREATE_TEMPLATE_ROUTE.REQUEST, _createTemplateRoute);
}

/**
 * @param action
 */
function* _updateTemplateRoute(action) {
  try {
    yield put(TemplateRouteActions.updateTemplateRouteLoading(true));
    const templateRoute = yield TemplateRouteServices.updateTemplateRoute(action.payload);
    if (templateRoute.success) {
      yield put(TrackerActions.trackAction(templateRouteActionTypes.UPDATE_TEMPLATE_ROUTE.SUCCESS, templateRoute.data));
      notification.open({
        type: 'success',
        message: 'Template Routes successfully updated',
        duration: 4,
        placement: 'top',
      });
      action.callback();
      yield put(TemplateRouteActions.updateTemplateRouteLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: templateRoute?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(TemplateRouteActions.updateTemplateRouteLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TemplateRouteActions.updateTemplateRouteLoading(false));
    yield put(TrackerActions.trackAction(templateRouteActionTypes.UPDATE_TEMPLATE_ROUTE.ERROR, error));
  }
}

/**
 *
 */
function* updateTemplateRoute() {
  yield takeLatest(templateRouteActionTypes.UPDATE_TEMPLATE_ROUTE.REQUEST, _updateTemplateRoute);
}

/**
 * @param action
 */
function* _updateAssignee(action) {
  try {
    yield put(TemplateRouteActions.updateAssigneeLoading(true));
    const assignee = yield TemplateRouteServices.updateAssignee(action.payload);
    if (assignee.success) {
      yield put(TrackerActions.trackAction(templateRouteActionTypes.UPDATE_ASSIGNEE.SUCCESS, assignee.data));
      notification.open({
        type: 'success',
        message: 'Assignee successfully updated',
        duration: 4,
        placement: 'top',
      });
      action.callback();
      yield put(TemplateRouteActions.updateAssigneeLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: assignee?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(TemplateRouteActions.updateAssigneeLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TemplateRouteActions.updateAssigneeLoading(false));
    yield put(TrackerActions.trackAction(templateRouteActionTypes.UPDATE_ASSIGNEE.ERROR, error));
  }
}

/**
 *
 */
function* updateAssignee() {
  yield takeLatest(templateRouteActionTypes.UPDATE_ASSIGNEE.REQUEST, _updateAssignee);
}

/**
 * @param action
 */
function* _getTemplateRoutes(action) {
  try {
    yield put(TemplateRouteActions.getTemplateRoutesLoading(true));
    const {
      orgId, page, limit, searchKeyword, tenants,
    } = action;
    const templateRoutes = yield TemplateRouteServices.getTemplateRoutes(orgId, page, limit, searchKeyword, tenants);
    yield put(TemplateRouteActions.getTemplateRoutesSuccess(templateRoutes));
    yield put(TemplateRouteActions.getTemplateRoutesLoading(false));
  } catch (error) {
    yield put(TemplateRouteActions.getTemplateRoutesLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(templateRouteActionTypes.GET_TEMPLATE_ROUTES.ERROR, error));
  }
}

/**
 *
 */
function* getTemplateRoutes() {
  yield takeLatest(templateRouteActionTypes.GET_TEMPLATE_ROUTES.REQUEST, _getTemplateRoutes);
}

/**
 * @param action
 */
function* _getTemplateRouteById(action) {
  try {
    yield put(TemplateRouteActions.getTemplateRouteByIdLoading(true));
    const {
      orgId, templateRouteId, callback,
    } = action;
    const selectedTemplateRoute = yield TemplateRouteServices.getTemplateRouteById(orgId, templateRouteId);
    yield put(TemplateRouteActions.getTemplateRouteByIdSuccess(selectedTemplateRoute));
    if (callback) callback(selectedTemplateRoute?.data?.[0]);
    yield put(TemplateRouteActions.getTemplateRouteByIdLoading(false));
  } catch (error) {
    yield put(TemplateRouteActions.getTemplateRouteByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(templateRouteActionTypes.GET_TEMPLATE_ROUTE_BY_ID.ERROR, error));
  }
}

/**
 *
 */
function* getTemplateRouteById() {
  yield takeLatest(templateRouteActionTypes.GET_TEMPLATE_ROUTE_BY_ID.REQUEST, _getTemplateRouteById);
}

/**
 * @param action
 */
function* _updateTemplateRouteStatus(action) {
  try {
    yield put(TemplateRouteActions.updateTemplateRouteStatusLoading(true));
    const {
      payload, callback,
    } = action;
    const state = yield select();
    const isV2Enabled = state.UserReducers?.user?.tenant_info?.global_config?.settings?.enable_jw_v2;
    let templateRoute;
    if (isV2Enabled) {
      templateRoute = yield TemplateRouteServices.updateTemplateRouteStatusV2(payload);
    } else {
      templateRoute = yield TemplateRouteServices.updateTemplateRouteStatus(payload);
    }
    if (templateRoute.success) {
      notification.open({
        type: 'success',
        message: 'Job card status updated successfully',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: templateRoute?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(TemplateRouteActions.updateTemplateRouteStatusLoading(false));
  } catch (error) {
    yield put(TemplateRouteActions.updateTemplateRouteStatusLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(templateRouteActionTypes.UPDATE_STATUS_TEMPLATE_ROUTE.ERROR, error));
  }
}

/**
 *
 */
function* updateTemplateRouteStatus() {
  yield takeLatest(templateRouteActionTypes.UPDATE_STATUS_TEMPLATE_ROUTE.REQUEST, _updateTemplateRouteStatus);
}

/**
 * @param action
 */
function* _deleteTemplateRoute(action) {
  try {
    yield put(TemplateRouteActions.deleteTemplateRouteLoading(true));
    const templateRoute = yield TemplateRouteServices.deleteTemplateRoute(action.payload);

    if (templateRoute.success) {
      notification.open({
        type: 'success',
        message: ' Template Route successfully deleted',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: templateRoute?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(TemplateRouteActions.deleteTemplateRouteLoading(false));
  } catch (error) {
    yield put(TemplateRouteActions.deleteTemplateRouteLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(templateRouteActionTypes.DELETE_TEMPLATE_ROUTE.ERROR, error));
  }
}

/**
 *
 */
function* deleteTemplateRoute() {
  yield takeLatest(templateRouteActionTypes.DELETE_TEMPLATE_ROUTE.REQUEST, _deleteTemplateRoute);
}

/**
 *
 */
export default function* templateRouteSaga() {
  yield all([
    createTemplateRoute(), getTemplateRoutes(), updateTemplateRoute(), getTemplateRouteById(), updateTemplateRouteStatus(), deleteTemplateRoute(), updateAssignee(),
  ]);
}
